import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormHelperText,
  Tabs,
  Tab,
  Paper,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import AgGridPaginatedTable from "../../component/AgGridPaginatedTable";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { CloudUpload, RemoveRedEye } from "@mui/icons-material";
import { AttendanceTable as tableDef } from "../../config/grid-columns-defs";
import { handleAxiosError } from "../../config/action-config";
import { showAlert } from "../../actions/alert";
import DeleteAlertDialog from "../../component/DeleteAlertDialog";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getAllWorkingStatusData,
  postWorkingStatus,
} from "../../api/workingStatus";
import {
  DatePicker,
  DesktopDateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs from "dayjs";
import TabPanel from "../../component/TabPanel";
import { getEmployeesList } from "../../api/employee";
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));
export default function WorkingStatus() {
  const classes = useStyles();
  const location = useLocation();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const [itemDialog, setItemDialog] = useState(false);
  const params = useParams();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  useEffect(() => {
    refreshTable();
  }, [tabIndex, employeeName, status, startDate, endDate]);
  async function loadMasterData(limit, offset) {
    try {
      const { data } = await getAllWorkingStatusData(
        {
          week_day: tabIndex === 0 ? "Y" : "N",
          limit,
          offset,
          name: employeeName,
          status: status,
          datefrom: startDate,
          dateto: endDate,
        },
        user.token
      );

      return {
        rows: data.data.WorkingStatus,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      //   setLoading(false);
    }
  }

  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  const onItemDialogSubmit = async (postData) => {
    // if (postData.status === "Working") {
    //   postData.status = "WFH";
    // } else {
    //   postData.status = "L";
    // }

    try {
      const { data } = await postWorkingStatus(postData, user.token);
      refreshTable();
      dispatch(showAlert(data.msg));
      setItemDialog(false);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  let action = tableDef.find((o) => o.headerName === "Action");

  if (action === undefined) {
    tableDef.unshift({
      headerName: "Action",
      field: "actions",
      resizable: true,
      wrapText: true,
      autoHeight: true,
      minWidth: 65,
      maxWidth: 70,
      headerClass: "justify-center",
      cellClass: "pmt-ag-cell-font justify-center",
      cellRendererFramework: (params) => (
        <IconButton
          color="info"
          onClick={() => {
            navigate(`/working-status/${params.data.id}`);
          }}
        >
          <RemoveRedEye fontSize="inherit" />
        </IconButton>
      ),
    });
  }

  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Working Status
          </Typography>
        </Box>

        <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
          {/* <Button
            variant="contained"
            sx={{
              padding: "5px 7px",
              fontSize: { xs: "10px", sm: "12px" },
              marginRight: "10px",
            }}
            onClick={() => {
              navigate("/working-status");
            }}
            className="blue-button"
          >
            Go Back
          </Button> */}
          <Button
            variant="contained"
            sx={{
              padding: "5px 7px",
              fontSize: { xs: "10px", sm: "12px" },
            }}
            onClick={() => {
              setItemDialog(true);
            }}
            className="blue-button"
          >
            Create
          </Button>
        </Box>
      </Box>
      <br />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          boxShadow: "0 4px 6px -1px #d0d0d0",
          borderRadius: "6px",
          padding: { sm: "15px 20px", xs: "8px 8px" },
          background: "#178af4",
          color: "#101728",
          width: "100%",
        }}
      >
        <Grid
          container
          className="report-filter-box"
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        >
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <TextField
              name="name"
              size="small"
              fullWidth
              value={employeeName}
              onChange={(e) => {
                setEmployeeName(e.target.value);
              }}
              label="Employee Name"
              type="text"
              // variant="outlined"
            />
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label" size="small">
                Status
              </InputLabel>
              <Select
                className={classes.textfeild}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={status}
                label="Status"
                size="small"
                sx={{ background: "#fff" }}
                onChange={(e) => {
                  setStatus(e.target.value);
                }}
              >
                <MenuItem value="WFH">Working</MenuItem>
                <MenuItem value="L">On Leave</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                inputFormat="MM/dd/yyyy"
                label="Date From"
                value={startDate}
                onChange={(newValue) => {
                  setStartDate(FormattedDate(newValue));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    size="small"
                    sx={{ background: "#fff", borderRadius: "4px" }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                inputFormat="MM/dd/yyyy"
                label="Date To"
                shouldDisableDate={disablePrevDates(startDate)}
                value={endDate}
                onChange={(newValue) => {
                  setEndDate(FormattedDate(newValue));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    size="small"
                    sx={{ background: "#fff", borderRadius: "4px" }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ borderBottom: 1, width: '100%' ,borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Working Days"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="Over-Time"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <Paper className="pmt-controll-table">
          <AgGridPaginatedTable
            getTableRows={loadMasterData}
            columns={tableDef}
            perPage={20}
            
            refreshCounter={tableRefreshCount}
          />
        </Paper>
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <Paper>
          <AgGridPaginatedTable
            getTableRows={loadMasterData}
            columns={tableDef}
            perPage={10}
            refreshCounter={tableRefreshCount}
          />
        </Paper>
      </TabPanel>
      {/*Notes and Audit tab*/}

      {loading && (
        <div className="overlay">
          <Loading></Loading>
        </div>
      )}
      <ItemDialogTab
        open={itemDialog}
        setOpen={setItemDialog}
        onSubmit={onItemDialogSubmit}
      />
    </Box>
  );
}

const emptyItemData = {
  status: "",
  emp_email: "",
  clock_in_time: new Date(), // Initialize with the current date and time
};
function ItemDialogTab({ open, setOpen, onSubmit }) {
  const user = useSelector((state) => state.user);
  const [loader, setLoader] = useState(false);
  const [employeesList, setEmployeesList] = useState([]);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    control,
    setError, // Add setError function
    reset,
    formState: { errors },
  } = useForm({ defaultValues: emptyItemData });

  const submit = (data) => {
    setLoader(true);
    onSubmit(data).then(() => {
      setLoader(false);
    });
  };

  // Use the clearStatusFieldError function when the dialog is opened
  useEffect(() => {
    if (open) {
      // Reset the form when the dialog is opened
      reset(emptyItemData);
    }
  }, [open, reset]);
  useEffect(() => {
    employeeList();
  }, []);

  const employeeList = async () => {
    const token = user.token;
    return await getEmployeesList({ name: "" }, token)
      .then((res) => {
        setEmployeesList(res.data.data);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  const workingStatusOptions = ["On Leave", "Working"];
  return (
    <Dialog
      open={open}
      onClose={() => {
        // setOpen(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
        Working Status Entry
      </DialogTitle>
      <DialogContent>
        <Grid container width={500} spacing={1} py={1}>
          <Grid item xs={12} sm={12} md={12}>
            <FormControl fullWidth required error={Boolean(errors.status)}>
              <InputLabel id="demo-simple-select-label-a">
                Working Status
              </InputLabel>
              <Controller
                render={(props) => (
                  <Select value={props.value} onChange={props.onChange}>
                    <MenuItem value="WFH">Working</MenuItem>
                    <MenuItem value="L">On Leave</MenuItem>
                  </Select>
                )}
                name="status"
                control={control}
                rules={{
                  required: "Please select working status",
                }}
              />
              <FormHelperText>{errors.status?.message}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <FormControl fullWidth required error={Boolean(errors.emp_email)}>
              <InputLabel id="demo-simple-select-label-a">
                Employee Email
              </InputLabel>
              <Controller
                render={(props) => (
                  <Select value={props.value} onChange={props.onChange}>
                    {employeesList.map((e, i) => (
                      <MenuItem key={i} value={e.email}>
                        {e.email}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                name="emp_email"
                control={control}
                rules={{
                  required: "Please select Employee email address",
                }}
              />
              <FormHelperText>{errors.emp_email?.message}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <FormControl
              required
              fullWidth
              error={Boolean(errors.clock_in_time)}
            >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Controller
                  render={(props) => (
                    <DesktopDateTimePicker
                      value={props.value || ""}
                      // shouldDisableDate={disablePrevDates(
                      //   dayjs(new Date()).subtract(1, "days").toJSON()
                      // )}
                      label="Clock In Time"
                      onChange={(nv) => {
                        props.onChange(nv);
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          error={Boolean(errors.follow_date)}
                          {...params}
                        />
                      )}
                    />
                  )}
                  rules={{
                    required: "Follow Up is required",
                  }}
                  name="clock_in_time"
                  control={control}
                />
              </LocalizationProvider>
              <FormHelperText>{errors.clock_in_time?.message}</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
          }}
          className="cancel-button"
        >
          Cancel
        </Button>

        {loader ? (
          <div className="overlay">
            <Loading></Loading>
          </div>
        ) : (
          <Button className="blue-button" onClick={handleSubmit(submit)}>
            {"Submit"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

function Loading() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <CircularProgress />
      </div>
    </div>
  );
}
function FormattedDate(newValue) {
  var newDate = newValue.toLocaleDateString();
  var dateArray = newDate.split("/");
  return (
    dateArray[2] +
    "-" +
    dateArray[0].padStart(2, "0") +
    "-" +
    dateArray[1].padStart(2, "0")
  );
}

function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
